import {
  FETCH_STUDENTS_FOR_SCHOOL_BEGIN,
  FETCH_STUDENTS_FOR_SCHOOL_FULFILLED,
  FETCH_STUDENTS_FOR_SCHOOL_REJECTED
} from "../actions/studentActions";

export function studentsForSchoolReducer(
  state = {
    loading: false,
    result: [],
    schoolResult: [],
    error: null
  },
  action
) {
  switch (action.type) {
    case FETCH_STUDENTS_FOR_SCHOOL_BEGIN: {
      return { ...state, loading: true };
    }
    case FETCH_STUDENTS_FOR_SCHOOL_REJECTED: {
      return { ...state, loading: false, error: action.payload };
    }
    case FETCH_STUDENTS_FOR_SCHOOL_FULFILLED: {
      return {
        ...state,
        loading: false,
        result: action.payload
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
}
